import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { BooleanInput, Datagrid, FunctionField, List, SearchInput, useTranslate } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE } from "../constants/resources";
import { customerServiceOrganizationPath } from "../lib/customerServiceOrganizationRoutes";
import type { CustomerServiceOrganizationRow } from "../lib/customerServiceOrganizations";
import { OrganizationAccountLink } from "./OrganizationAccountLink";

export const CustomerServiceOrganizationList = () => {
  const translate = useTranslate();
  const filters = useMemo(
    () => [
      <SearchInput
        key="search"
        source="search"
        placeholder={translate("customerServiceOrganizations.searchPlaceholder")}
        alwaysOn
        sx={{ minWidth: 300 }}
      />,
      <BooleanInput
        key="unlinked"
        source="unlinked"
        label={translate("customerServiceOrganizations.filters.unlinked")}
        alwaysOn
      />,
    ],
    [translate]
  );

  return (
    <Box data-testid="customer-service-organization-list">
      <Typography component="h1" variant="h4" align="left" marginY={2}>
        {translate("customerServiceOrganizations.title")}
      </Typography>
      <List
        resource={CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE}
        title={translate("customerServiceOrganizations.title")}
        filters={filters}
        actions={false}
        empty={false}
        perPage={ROWS_PER_PAGE}
      >
        <Datagrid bulkActionButtons={false} rowClick={id => customerServiceOrganizationPath(String(id))}>
          <FunctionField
            label={translate("customerServiceOrganizations.fields.name")}
            sortable={false}
            render={(organization: CustomerServiceOrganizationRow) => organization.name || organization.id}
          />
          <FunctionField
            label={translate("customerServiceOrganizations.fields.account")}
            sortable={false}
            render={(organization: CustomerServiceOrganizationRow) => (
              <OrganizationAccountLink
                salesforceAccountId={organization.salesforceAccountId}
                salesforceAccountName={organization.salesforceAccountName}
              />
            )}
          />
        </Datagrid>
      </List>
    </Box>
  );
};
